<template lang="pug">
v-app
  section
    .d-flex.row.flex-row.align-items-end
      .col-12
        h2.ps_titulo
          i Diálogos de desempeño
    .d-flex.row.flex-row.align-items-start
      .col-6
        .card.ad_border1-secondary.rounded-xl
          h4.ad_text-primary
            i Objetivos para la semana
          div(v-if="currentWeekObjectives.length > 0")
            .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(lwobj, index) in currentWeekObjectives")
              form
                .d-flex.row.form-group.align-items-end.mb-1
                  .col
                    a(:id="'viaje' + index")
                      i.icon-letters.icon-letters__viaje.mr-2(v-if="lwobj._id.travel.length > 0") V
                      i.icon-letters.icon-letters__producto.mr-2(v-if="lwobj._id.product.length > 0") P
                      i.icon-letters.icon-letters__segmento.mr-2(v-if="lwobj._id.segment.length > 0") S
                    b-tooltip(:target="'viaje' + index" , placement='top')
                      | {{lwobj._id.travel.length > 0 ? lwobj._id.travel[0].name : ''}}+{{lwobj._id.product.length > 0 ? lwobj._id.product[0].name : ''}}+{{lwobj._id.segment.length > 0 ? lwobj._id.segment[0].name : ''}}
                    a(:id="'kpi' + index")
                      i.icon-letters.icon-letters__negocio.mr-1 N
                    b-tooltip(:target="'kpi' + index" , placement='top')
                      | {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].name: ''}}
                    | {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].name: ''}}
                  .col-auto
                    p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                      sup Registro
                      span {{lwobj.objectives[0].businesspercentage}}%
                    p.d-inline-block.mb-0.ad_text-grayMedio
                      sup Meta
                      span {{lwobj._id.business_type.length > 0 ? lwobj._id.business_type[0].goal: ''}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th
                        th 
                        th.px-0 Registro
                        th.px-0 Meta
                        th
                        th
                    tbody
                      tr(v-for="(currentwo, n) in lwobj.objectives")
                        td
                          div.pr-0
                            span.num_circle.ad_bg-success {{n + 1}}
                        td.text-left
                          div.pl-2(v-for="names in currentwo.kpi")
                            | {{names ? names.name : "Sin Kpi"}}
                        td
                          div.px-0.text-nowrap
                            span.ad_text-success
                              | {{currentwo.date | WeekDuration}}&deg; sem
                        td
                          div.pr-0.justify-content-center.text-info
                            | {{currentwo.open ? "Libre" : ""}}
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.kpipercentage}}%
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.kpi.goal}}%
                        td
                          div.px-0
                            a.no-decoration(href="#" title="Comentarios" @click.stop='openObjDetail(currentwo._id)')
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div.pl-1
                            input.form-checkbox.text-none(type="checkbox", :id="currentwo._id", label="", :value="currentwo" v-model="objSelected")                             
          .form-group.row
            .col-12
              textarea.form-control(placeholder='Descripción' v-model="description" requiere)
          .form-group.row
            .col-6.position-relative
              v-menu(ref='menu', v-model='menu', :close-on-content-click='true', :nudge-right='40', lazy, transition='scale-transition', offset-y, full-width, min-width='290px', content-class='date-picker')
                v-text-field.date-input.pt-0.mt-0(slot='activator', v-model='date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                v-date-picker(v-model='date', no-title, locale="es", :min="startWeek", :max="endWeek", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              
            //- .col-6.d-flex.justify-content-end
            //-   button.btn.btn-secondary.btn__large(:class='{disabled : !checkbox1 && !checkbox2 && !checkbox3}' @click="create()")
            //-     | Crear DDD
            //-     i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2
            .col-6.d-flex.justify-content-end
              button.btn.btn-secondary.btn__large(@click="create()")
                | Crear DDD
                i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2

      .col-6
        .card.ad_border1-secondary.rounded-xl
          h4.ad_text-primary
            i DDDs para la semana
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='meetings.length == 0')
              p.muted Aún no ha seleccionado nuevos objetivos
          div(v-if='meetings.length > 0')
            .col-12.py-2.rounded-xl.ad_border1-primaryLight.mb-3(v-for="(me, j) in meetings")
              .row.mb-1
                .col-8
                  span.h4.font-weight-bold.mr-1 {{(me) ? me.name: ''}}
                  | {{(me) ? me.description: ''}}
                .col-4.d-flex.justify-content-between
                  span.h4.font-italic  {{(me) ? me.date_scheduled : '' | DateFormat}}
                  button.btn-icon.p-0.ad_text-danger.border-btnicon-danger.rounded-circle(@click="closeMeet(me._id)" :id="'eliminaddd' + j")
                    i.fas.fa-times.p-0
                  b-tooltip(:target="'eliminaddd' + j" , placement='top')
                    | Eliminar DDD
              .d-flex.flex-row
                .col-12.py-2.ad_bg-gray.rounded-xl
                  table.w-100.table-rounded-body
                    thead
                      tr
                        th.px-0(colspan="4") Objetivos
                    tbody
                      tr(v-for="(obj, obj_index) in me.objectives")
                        td(valign='top')
                          div
                            a.d-flex.flex-nowrap(:id="'obvieje' + obj_index + j")
                              i.icon-letters.icon-letters__viaje(v-if="obj.travel") V
                              i.icon-letters.icon-letters__producto.mx-2(v-if="obj.product") P
                              i.icon-letters.icon-letters__segmento(v-if="obj.segment") S
                            b-tooltip(:target="'obvieje' + obj_index + j" , placement='top')
                              | {{obj.open ? "" : obj.travel ? obj.travel.name : ""}}+{{obj.open ? "" : obj.product ? obj.product.name : ""}}+{{obj.open ? "" : obj.segment ? obj.segment.name : ""}}
                        td(valign='top')
                          div
                            a(:id="'obkpi' + obj_index + j")
                              i.icon-letters.icon-letters__negocio.ml-1 N
                            b-tooltip(:target="'obkpi' + obj_index + j" , placement='top')
                              | {{(obj.business_type) ? (obj.business_type.name) ? obj.business_type.name: obj.business_type.length > 0 ? obj.business_type[0].name : '' : ''}}
                        td(valign='top')
                          div
                            i.icon-letters.icon-letters__kpi.mx-1 A
                            | {{obj.kpi ? (Array.isArray(obj.kpi)) ? obj.kpi.length > 0 ? obj.kpi[0].name : 'Sin Kpi' : obj.kpi.name : 'Sin Kpi'}}
                        td.text-right
                          div
                            a.no-decoration.h3.text-thin(href="#" title="Comentarios" @click.stop='openObjDetail(obj._id)')
                              i.icono.icono-comentarios.ad_text-primary                          
          .col-12.text-center.mt-4.ad_bg-warningLight.rounded-lg.py-2(v-show="meetings.length < user.profile.suggested_ddd")
            p.ad_text-warningDark.m-0
              i.fas.fa-exclamation-triangle.mr-2
              i Falta por asignar {{suggested}} DDD
    
    v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .row.m-0.align-items-end(v-if="objective")
          .col
            label
              a(id="obviejecom")
                i.icon-letters.icon-letters__viaje.mr-1(v-if="objective.travel") V
                i.icon-letters.icon-letters__producto.mr-1(v-if="objective.product") P
                i.icon-letters.icon-letters__segmento.mr-1(v-if="objective.segment") S
              b-tooltip(target="obviejecom" , placement='top')
                | {{(objective) ? objective.travel ? objective.travel.name : '' : ''}} + {{(objective) ? objective.product ? objective.product.name : '' : ''}} + {{(objective) ? objective.segment ? objective.segment.name : '' : ''}}
            
              a(id="adherenciacom")
                i.icon-letters.icon-letters__negocio.mr-1 N
              b-tooltip(target="adherenciacom" , placement='top')
                | {{(objective) ? objective.business_type.name : ''}}
            label
              i.icon-letters.icon-letters__kpi.mr-1 A
              | {{(objective) ? objective.kpi ? objective.kpi.name: 'Sin Kpi' : ''}}
          
          .col-auto
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span.ad_text-grayDark 60%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span 90%
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToObjective(objective._id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="objective")
            .row.mb-3(v-for='comm in objective.comments')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{comm.date | DateFormat}}
                small.d-block {{comm.date | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.text}}
                  div.px-0(v-if="moment(comm.date).week() == moment(plan.date).week()")
                    a.no-decoration(href="#" title="Editar" @click.stop='OpenEditCommObj(objective._id, comm._id, comm.text)')
                      i.icono.icon-pencil3.ad_text-primary
    b-modal(:id='editCommModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
      <template v-slot:modal-title>
        h3.font-weight-bold.mb-0 {{editCommModal.title}}
      </template>
      textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='commentObjectiveEdit')
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        .col-12.d-flex.justify-content-around
            b-button.px-4(size="lg", variant="danger", @click="closeCommentUpdate()")
              | Cancelar
            b-button.px-4(size="lg", variant="success", @click="editCommentObjective()")
              | Editar
      </template>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Flatpickr from 'vendors/cover/vendors/flatpickr'

export default {
  name: 'PSDialogosDesempeno',
  props: ['clickedNext', 'currentStep'],
  components: {
     Flatpickr
  },
  data() {
      return {
        n: 0,
        description: null,
        menu: false,
        date: null, 
        cumplimiento: 'cumple',
        drawer: null,
        drawer2: null,
        overlay: false,
        moveobjetivo: false,
        currentWeekObjectives: [],
        comment: null,
        objective: null,
        plan: null,
        objSelected: [],
        meetings: [],
        meetingtypes: [],
        meeting: null,
        pendent: 0,
        startWeek: moment().utc().startOf('isoWeek').subtract(1, "days").toISOString(),
        endWeek: moment().utc().endOf('isoWeek').toISOString(),
        user: {},
        suggested: 0,
        editCommModal: {
          id: 'edit-comment',
          title: 'Editar',
          comm_text: '',
          objective_id: null,
          comment_id: null
        },
        commentObjectiveEdit: ''
      }
  },
  methods: {
    moment,
    ...mapActions('meeting', [
      'createMeeting', 'getMeetingsByPlan', 'getMeetingById', 'deleteMeeting', 'getMeetingsByPlanOpen'
    ]),
    ...mapActions('meetingtype', [
      'meetingtypesList'
    ]),
    ...mapActions('objective', [
      'addComment', 'getObjectiveById', 'close', 'getObjectiveByPlan', 'updateObjectComment'
    ]),
    create() {
      const vm = this
      const loading = vm.$toast.loading('Creando...')
      vm.meetingtypesList({name: "DDD"}).then(() => {
        vm.meetingtypes = vm.$store.getters['meetingtype/getMeetingtypes']
        if (vm._validate()) {
          vm.createMeeting({
            description: vm.description,
            date_scheduled: vm.date,
            plan: vm.plan,
            objectives: vm.objSelected,
            meetingtype: vm.meetingtypes[0],
            user_leader: vm.$store.state.auth.user.id
          }).then(() => {
            vm.meetings = vm.$store.getters['meeting/getMeetings']
            const value = (vm.meetings.length >= vm.user.profile.suggested_ddd) ? true : false 
            vm.$emit('can-continue', { value });
            vm._cleanform()
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: "DDD creado",
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          loading.hide()  
        }
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });      
    },   
    addCommentToObjective(id) {
      const vm = this
      let comm = {
        user: vm.user.name,
        date: moment(),
        text: vm.comment
      }
      vm.addComment({
        id: id,
        comment: comm  
      }).then(() => {
        vm.objective.comments.push(comm)
        vm.drawer2 = false        
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    openObjDetail(id) {
      const vm = this              
      vm.getObjectiveById(id).then(() => {        
        vm.objective = vm.$store.getters['objective/getObjective']        
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    openUpdateDetail(id) {
      const vm = this              
      vm.getObjectiveById(id).then(() => {        
        vm.meeting = vm.$store.getters['meeting/getMeeting']        
        vm.drawer = !vm.drawer
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    closeMeet(id) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      vm.deleteMeeting(id).then(() => {
        vm.meetings = vm.$store.getters['meeting/getMeetings']    
        const value = (vm.meetings.length >= vm.user.profile.suggested_ddd) ? true : false 
        vm.$emit('can-continue', { value });
        loading.hide()
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'DDD cerrado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _cleanform() {
      const vm = this
      vm.objSelected = []
      vm.description = null
      vm.date = null
    },
    _checkPendent() {
      const vm = this
      if (vm.currentWeekObjectives.length > 0) {
        for (let group of vm.currentWeekObjectives) {
          for (let obj of group.objectives) {
            if (vm.meetings.length > 0) {
              let is = false
              for (let meet of vm.meetings) {
                for (let mobj of meet.objectives) {
                  if (mobj._id == obj._id) {
                    is = true
                  }
                }
              }
              if (!is) {
                vm.pendent += 1
              }
            } else {
              vm.pendent = 0
            }
          }
        }
      }
    },
    _validate() {
      const vm = this
      let valid = true
      let missing = ''
      
      if (vm.description == null) {
        missing = 'descripción'
        valid = false
      } else if (vm.date == null) {
        missing = 'fecha'
        valid = false
      } else if (vm.objSelected.length == 0) {
        missing = 'objetivos'
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: `Debe completar el campo ${missing}`,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    _meetingShortness() {
      const vm = this
      if (vm.meetings.length > 0) {
        if (vm.meetings.length < vm.user.profile.suggested_ddd) {
          vm.suggested = +(vm.user.profile.suggested_ddd) - +(vm.meetings.length)
        }
      } else {
        vm.suggested = vm.user.profile.suggested_ddd
      }
    },
    OpenEditCommObj(objective_id, comment_id, comm_text) {
      const vm = this;
      vm.$bvModal.show(vm.editCommModal.id)
      vm.commentObjectiveEdit = comm_text;
      vm.editCommModal.objective_id = objective_id;
      vm.editCommModal.comment_id = comment_id;
    },
    editCommentObjective() {
      const vm = this;
      let data = {
        id:  vm.editCommModal.objective_id,
        comment_id: vm.editCommModal.comment_id,
        text: vm.commentObjectiveEdit
      }
      vm.updateObjectComment(data).then((objective) => {
        vm.objective = objective;
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    closeCommentUpdate() {
      const vm = this;
      vm.$bvModal.hide(vm.editCommModal.id);
      vm.drawer2 = !vm.drawer2
    }
  },
  watch: {
    currentWeekObjectives: function () {
      const vm = this
      vm._checkPendent()
    },
    meetings: function () {
      const vm = this
      vm._meetingShortness()
      vm._checkPendent()
    },
    currentStep: function(){
      const vm = this
      const value = (vm.meetings.length >= vm.user.profile.suggested_ddd) ? true : false 
      vm.$emit('can-continue', { value });
    }
  },
  mounted() {
    const vm = this
    const loading = vm.$toast.loading('Cargando...') 
    vm.plan = vm.$store.getters['plan/getPlan']
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.getObjectiveByPlan({id: vm.plan._id, user: vm.user.id}).then(() => {
      vm.currentWeekObjectives = vm.$store.getters['objective/getObjectives']
      vm.getMeetingsByPlanOpen(vm.plan._id).then(() => {        
        vm.meetings = vm.$store.getters['meeting/getMeetings']
        const value = (vm.meetings.length >= vm.user.profile.suggested_ddd) ? true : false 
        vm.$emit('can-continue', { value });
        vm._meetingShortness();
        if (vm.meetings.length > 0) {
          vm._checkPendent()
        }
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  },
};

</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/views/ps-ddd.vue